<!--<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.64016L4.05047 11.8017C4.20673 12.0661 4.45993 12.0661 4.6162 11.8017L11 1"
      stroke="#001D7E"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>-->

<template>
  <svg
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.64016L4.05047 11.8017C4.20673 12.0661 4.45993 12.0661 4.6162 11.8017L11 1"
      stroke-linecap="round"
      stroke-width="3"
      />
  </svg>
</template>
